<template>
  <div class="copy-button">
    <div v-if="!isCopied" @click="copyToClipboard">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
      >
        <path
          d="M10.6666 8.6V11.4C10.6666 13.7333 9.73331 14.6667 7.39998 14.6667H4.59998C2.26665 14.6667 1.33331 13.7333 1.33331 11.4V8.6C1.33331 6.26667 2.26665 5.33334 4.59998 5.33334H7.39998C9.73331 5.33334 10.6666 6.26667 10.6666 8.6Z"
          stroke="#2B5DE5"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          opacity="0.4"
          d="M14.6666 4.6V7.4C14.6666 9.73334 13.7333 10.6667 11.4 10.6667H10.6666V8.6C10.6666 6.26667 9.73331 5.33334 7.39998 5.33334H5.33331V4.6C5.33331 2.26667 6.26665 1.33334 8.59998 1.33334H11.4C13.7333 1.33334 14.6666 2.26667 14.6666 4.6Z"
          stroke="#2B5DE5"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
    <p v-else>{{ $t("button.general.copied") }}</p>
  </div>
</template>

<script>
export default {
  name: "CopyButton",
  props: {
    value: {
      required: true,
    },
  },
  data() {
    return {
      isCopied: false,
    };
  },
  methods: {
    copyToClipboard() {
      this.isCopied = true;
      navigator.clipboard.writeText(this.value).then(() => {
        setTimeout(() => {
          this.isCopied = false;
        }, 1000);
      });
    },
  },
};
</script>

<style scoped>
.copy-button {
  @apply text-xs h-5 w-9 flex items-center justify-center;
}
.copy-button p {
  @apply text-[10px] font-semibold text-primary-base cursor-default;
}
.copy-button svg {
  @apply cursor-pointer;
}
</style>
